const Companies = [
  "Adobe",
  "Amazon",
  "Arcesium",
  "Atlassian",
  "Cisco",
  "Deutsche Bank",
  "Edelweiss",
  "Goldman Sachs",
  "Google",
  "LinkedIn",
  "Media.net",
  "Microsoft",
  "Oracle",
  "PhonePe",
  "Razorpay",
  "Rubrik",
  "Salesforce",
  "Slice",
  "Sprinklr",
  "Traceable.Ai",
  "Uber",
  "Zomato",
  "Other",
];

export default Companies;
